"use client";

import React from "react";
import { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.1,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const teamMembers = [{
  name: "Dr. Aris Thorne",
  role: "Clinical Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/team_marcus_vance.png"
}, {
  name: "Sarah Miller",
  role: "LMHC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/team_elena_rostova.png"
}, {
  name: "James Wilson",
  role: "LMHC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/team_david_chen.png"
}, {
  name: "Maya Rodriguez",
  role: "Clinical Associate",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/team_sarah_jenkins.png"
}];
export default function TheLogisticsExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}